import React, { useState } from 'react';
import { reloadWithFreshAssets } from '../utils/appUpdate';

const UpdateBanner = ({ latestVersion, onDismiss }) => {
    const [updating, setUpdating] = useState(false);

    const handleUpdate = async () => {
        setUpdating(true);
        await reloadWithFreshAssets();
    };

    return (
        <div
            role="status"
            className="fixed inset-x-0 bottom-0 z-[60] flex justify-center px-3 pointer-events-none"
            style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
        >
            <div className="pointer-events-auto w-full max-w-md bg-gray-900 text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3">
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold">Nuova versione disponibile</p>
                    <p className="text-xs text-gray-300">Versione {latestVersion}: aggiorna per usare le novità</p>
                </div>
                <button
                    type="button"
                    onClick={onDismiss}
                    disabled={updating}
                    className="text-xs text-gray-300 hover:text-white px-2 py-1"
                >
                    Più tardi
                </button>
                <button
                    type="button"
                    onClick={handleUpdate}
                    disabled={updating}
                    className="text-sm font-semibold bg-red-500 hover:bg-red-600 disabled:opacity-60 rounded-lg px-3 py-2 whitespace-nowrap"
                >
                    {updating ? 'Aggiorno...' : 'Aggiorna ora'}
                </button>
            </div>
        </div>
    );
};

export default UpdateBanner;
